import * as Yup from 'yup';
import { IOption } from '@shared/interfaces';
import { StepTypeEnum } from './types';

export const workflowFormValidationSchema = Yup.object().shape({
  name: Yup.string().min(1).max(128).required('Workflow Name is required'),
  entityType: Yup.string().required(),
});

export const stepFormValidationSchema = Yup.object().shape({
  workflowId: Yup.string().nullable(),
  displayName: Yup.string(),
  name: Yup.string().min(1).max(128).required(),
  description: Yup.string(),
  orderNumber: Yup.number().required(),
  stepType: Yup.string().required(),
  minutesAmber: Yup.number(),
  minutesGreen: Yup.number(),
  minutesRed: Yup.number(),
  isDefault: Yup.boolean(),
  trackerStageId: Yup.number(),
  trackerStepId: Yup.number(),
  textCommentColor: Yup.string(),
  isTextBold: Yup.boolean(),
  parentWorkflowStepId: Yup.string().nullable(),
  reRouteWorkflowStepId: Yup.string().nullable(),
  roleId: Yup.string().nullable(),
  stepPath: Yup.string().when('stepType', {
    is: (val: string) => val === StepTypeEnum.ReRouteAll || val === StepTypeEnum.ReRoute,
    then: Yup.string().required('Destination step is Required').nullable(),
    otherwise: Yup.string().nullable(),
  }),
});

export const parentStepFormValidationSchema = Yup.object().shape({
  parentWorkflowStepId: Yup.string().nullable(),
});

export const stepTypesOptionsMock: IOption[] = [
  {
    value: 'Step',
    label: 'Step',
  },
  {
    value: 'Fork',
    label: 'Fork',
  },
  {
    value: 'ReRoute',
    label: 'ReRoute',
  },
  {
    value: 'ReRouteAll',
    label: 'ReRouteAll',
  },
];

export const orderingMock: IOption[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 99].map(
  (number) => ({
    value: `${number}`,
    label: `${number}`,
  }),
);

export const colorsMock: IOption[] = [
  {
    value: 'Black',
    label: 'Black',
  },
  {
    value: 'Red',
    label: 'Red',
  },
  {
    value: 'Green',
    label: 'Green',
  },
  {
    value: 'Blue',
    label: 'Blue',
  },
  {
    value: 'Purple',
    label: 'Purple',
  },
];

export const entityTypeMock: IOption[] = [
  {
    label: 'Lead',
    value: 'Lead',
  },
  {
    label: 'Deal',
    value: 'Deal',
  },
];

export const reasonLenderMappingValidationSchema = Yup.object().shape({
  label: Yup.string().required().max(128, 'Label should not be max 128 symbols'),
  description: Yup.string().nullable().max(250, 'Last Name should be max 250 symbols'),
  lenderId: Yup.array(),
});
